export const SECTION_COLORS = {
  AUDIO: "#3B82F6",
  VIDEO: "#8B5CF6",
  LUCI: "#EAB308",
  STRUTTURE: "#A3A3A3",
  INFORMATICA: "#22C55E",
  "RISORSE UMANE": "#EC4899",
  ALTRO: "#06B6D4",
  ASSISTENZA: "#EC4899",
  "ALLESTIMENTO E SMONTAGGIO": "#F97316",
  LOGISTICA: "#06B6D4",
  OMAGGIO: "#10B981",
};

export const sectionColor = (s) => SECTION_COLORS[s] || "#94A3B8";

export const STATUS = {
  bozza: { label: "Bozza", cls: "bg-slate-700/60 text-slate-200" },
  inviato: { label: "Inviato", cls: "bg-sky-500/15 text-sky-300" },
  accettato: { label: "Accettato", cls: "bg-emerald-500/15 text-emerald-300" },
  rifiutato: { label: "Rifiutato", cls: "bg-red-500/15 text-red-300" },
};

export const ROLE_LABELS = {
  admin: "Amministratore",
  collaboratore: "Collaboratore",
  in_attesa: "In attesa di approvazione",
};

export const slug = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
export const EXTRA_CLAUSES = [["transenne", "Transenne, sicurezza e vigilanza"], ["traduzione", "Traduzione simultanea"], ["internet", "Rete internet"], ["vigilanza", "Vigilanza"], ["cena_tecnici", "Cena tecnici"]];
export const QUOTE_CATEGORIES = ["Service", "Noleggio", "Impianto", "Vendita", "Video"];
